// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/blueimp-gallery/css/blueimp-gallery.min.css
// module id = 1481
// module chunks = 0